import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '../../../contexts/user.context';
import { InfrastructureProjectType } from '../../../types/project.types';
import classes from './styles.module.scss';
import { getInfrastructureProjects } from '../../../requests/public-infrastructure';
import EducationTab from '../infrastructure-tabs/education-tab.component';
import HealthTab from '../infrastructure-tabs/health-tab.component';
import CultureTab from '../infrastructure-tabs/culture-tab.component';
import WaterTab from '../infrastructure-tabs/water-tab.component';
import InternetTab from '../infrastructure-tabs/internet-tab.component';
import AccessRoadTab from '../infrastructure-tabs/access-road-tab.component';
import VillageRoadTab from '../infrastructure-tabs/village-road-tab.component';
import LightingTab from '../infrastructure-tabs/lighting-tab.component';
const baseClass = 'infrastructure-projects-tab';

export const tabs = [
  { key: InfrastructureProjectType.EDUCATION, label: `settings-config.${InfrastructureProjectType.EDUCATION}` },
  { key: InfrastructureProjectType.HEALTH, label: `settings-config.${InfrastructureProjectType.HEALTH}` },
  { key: InfrastructureProjectType.CULTURE_SPORT, label: `settings-config.${InfrastructureProjectType.CULTURE_SPORT}` },
  { key: InfrastructureProjectType.WATER_SUPPLY, label: `settings-config.${InfrastructureProjectType.WATER_SUPPLY}` },
  { key: InfrastructureProjectType.INTERNET_COMMUNICATION, label: `settings-config.${InfrastructureProjectType.INTERNET_COMMUNICATION}` },
  { key: InfrastructureProjectType.ACCESS_ROAD, label: `settings-config.${InfrastructureProjectType.ACCESS_ROAD}` },
  { key: InfrastructureProjectType.VILLAGE_ROAD, label: `settings-config.${InfrastructureProjectType.VILLAGE_ROAD}` },
  { key: InfrastructureProjectType.LIGHTING, label: `settings-config.${InfrastructureProjectType.LIGHTING}` },
]

const InfrastructureProjectTabs = () => {
  const { t } = useTranslation();
  const { kato, link, tab, type } = useParams<{ kato: string, link: string, tab: string, type: InfrastructureProjectType }>();
  const navigate = useNavigate();
  const { isModulePresent, modules } = useUser();
  const [filteredTabs, setFilteredTabs] = useState<{ key: string, label: string }[]>([]);
  const [list, setList] = useState<any[]>([]);
  const [isOpen, setIsOpen] = useState<Record<string, boolean>>({});

  const onTabChange = (type: string) => {
    navigate(`/${kato}/${link}/${tab}/${type}`, { replace: true });
  }

  useEffect(() => {
    if (!kato) return;
    if (!type) {
      navigate(tabs.filter(tab => isModulePresent(tab.key))[0]?.key, { replace: true });
      return;
    }

    getInfrastructureProjects(kato, type).then((res: any) => {
      setList(res);
    });

  }, [type, kato])

  useEffect(() => {
    const filtered = tabs.filter(tab => isModulePresent(tab.key));
    setFilteredTabs(filtered);
  }, [isModulePresent, modules]);

  return (
    type && <div className={classes[baseClass]}>
      <div className={classes[`${baseClass}__tabs`]}>
        {filteredTabs.map(tab => (
          <div key={tab.key} className={`${classes[`${baseClass}__tab`]}  ${tab.key === type ? classes[`${baseClass}__tab--active`] : ''}`} onClick={() => onTabChange(tab.key)}>
            {t(tab.label)}
          </div>
        ))}
      </div>

      <div className={classes[`${baseClass}__content`]}>
        {type === InfrastructureProjectType.EDUCATION && <EducationTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
        {type === InfrastructureProjectType.HEALTH && <HealthTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
        {type === InfrastructureProjectType.CULTURE_SPORT && <CultureTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
        {type === InfrastructureProjectType.WATER_SUPPLY && <WaterTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
        {type === InfrastructureProjectType.INTERNET_COMMUNICATION && <InternetTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
        {type === InfrastructureProjectType.ACCESS_ROAD && <AccessRoadTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
        {type === InfrastructureProjectType.VILLAGE_ROAD && <VillageRoadTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
        {type === InfrastructureProjectType.LIGHTING && <LightingTab list={list} isOpen={isOpen} setIsOpen={setIsOpen} />}
      </div>
    </div>
  )
}

export default InfrastructureProjectTabs